/* eslint eqeqeq: "off", curly: "error", @typescript-eslint/no-unused-vars: "off", react-hooks/exhaustive-deps: "off", array-callback-return: "off", no-eval: "off", jsx-a11y/alt-text: "off", jsx-a11y/anchor-is-valid: "off" */
import React, { useState, useEffect } from "react";
import * as Modals from '../modals';
import * as API from "../../http/api";
import * as Elements from "../elements";
import { useHistory } from "react-router-dom";
import { openlightbox } from "../../util/Functions";
import { IconButton, Paper, Typography } from "@mui/material";
import { TrendingUp, AccountCircle } from "@mui/icons-material";
import { useStyles } from "../../util/ComponentStyles";
import { useVipValidation } from "./customer-vip/hooks/useVipValidation";

const Spaces = (props) => {
  const { onHandleValidate } = useVipValidation(props.changeAlert);
  const clasess = useStyles();
  const [radioData, setRadioData] = useState(null);
  const [propsModal, setPropsModal] = useState(props.item);
  const [cancelDisabled, setCancelDisabled] = useState(true);
  const [blockDisabled, setBlockDisabled] = useState(true);
  const [blocked, setBlocked] = useState(false);
  const [hasFilter, setHasFilter] = useState(false);
  const openpayPrefix = props.catalogs.openpayPrefix[0] ? props.catalogs.openpayPrefix[0].k : null;
  
  const [upgrade, setUpgrade] = useState(true);
  const [catalogLevel, setCatalogLevel] = useState([]);
  const [balance, setBalance] = useState("");
  const history = useHistory();
  const coin: any = { style: 'currency', currency: 'USD' };
  const numberFormat = new Intl.NumberFormat('en-US', coin);
  const [disabled, setDisabled] = useState(false);
  
  useEffect(() => {
    setCancelDisabled(true);
    setRadioData(null);
    if (localStorage.config) {
      let rol = localStorage.config && JSON.parse(localStorage.config)['idRol'] ? [JSON.parse(localStorage.config)['idRol']] : [];
    }
  }, [props.item]);

  useEffect(() => {
    if(props.item.data.content){
      let sumWithInitial = props.item.data.content.reduce(
        (accumulator, currentValue) => accumulator + currentValue.balance.disposable, 0
      );
      setBalance(numberFormat.format(sumWithInitial))
    }
  })

  const changeReload = async () => {
    props.changeLoader(true);
    let request = await API.service('cuentas', props.item.data.customerUuid, props.pos, props.changeAlert, props.changeLoader, history);
    if(request.status == 200 && request.data.data.response == 'OK'){
      setPropsModal(request.data.data.widget[1]);  
    }
    props.changeLoader(false);
}

  const onClickRadio = (data) => {
    if ( data.type === "5" || data.status == "disabled" || data.status == "Inactivo" || data.status == "cancel" || data.status == "Cancelada" || data.status == "Cancelado") {
      setCancelDisabled(true);
    } else {
      setCancelDisabled(false);
    }
    if (data.type === "5") {
      setBlockDisabled(true);
    } else {
      setBlockDisabled(false);
    }
    setRadioData(data);
    setBlocked(data.status === "Bloqueado");
  };

  const validation = async () => {
    let payload = {
      customerUuid: props.item.data.customerUuid,
      spaceUuid: radioData.uuid
    };
    props.changeLoader(true);

    const validate = await onHandleValidate(props.item.data.customerUuid);
    if(validate){
      let request = await API.service("openModalCancelAccount", payload, props.pos, props.changeAlert, props.changeLoader, history);
      if(request.status == 200 && request.data.data.response == "OK" && request.data.data.content){
        if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
          let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
          factors[props.item.data.customerUuid] = request.data.data.content.uuid_factor;
          localStorage.factors = JSON.stringify(factors);
        }
        const as = <Modals.Factor
            intent="openModalCancelAccount"
            contentModal={request.data.data.content}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            history={history}
            key="factor"
        />
        openlightbox(as);
      }
      if (request.status == 200 && request.data.data.response == "OK" && request.data.data.widget.length > 0) {
        let widg = request.data.data.widget[0];
        if(widg['type'] == 'spaceCancel'){
          cancel(widg);
        }
      }
    }
    props.changeLoader(false);
  };

  const blockW = async () => {
    if (radioData === null || radioData.lenght === 0) {
      return;
    }

    if ( blockDisabled || radioData.status == 'disabled' || radioData.status == 'Inactivo' || radioData.status == 'cancel' || radioData.status == 'Cancelada' || radioData.status == 'Cancelado') {
      return;
    }
    let data = {
      customerUuid: props.item.data.customerUuid, //TWO_FACTOR_AUTH,
      spaceUuid: radioData.uuid,
      openWidget: true,
    };
    props.changeLoader(true);

    let request = await API.service('openModalBlockAccount', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == "OK" && request.data.data.widget.length == 0 && request.data.data.content) {
      if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
        let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
        factors[props.item.data.customerUuid] = request.data.data.content.uuid_factor;
        localStorage.factors = JSON.stringify(factors);
      }
      const as = <Modals.Factor
          intent="openModalBlockAccount"
          contentModal={request.data.data.content}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          history={history}
          key="factor"
      />
      openlightbox(as);
    }
    if (request.status == 200 && request.data.data.response == "OK" && request.data.data.widget.length > 0) {
      let widg = request.data.data.widget;
      if (widg[0]?.type === "spaceBlock") {
        const as = (
          <Modals.SpaceBlock
            content={widg[0].content}
            customerUuid={props.item.data.customerUuid}
            pos={props.pos}
            changeAlert={props.changeAlert}
            changeLoader={props.changeLoader}
            blocked={blocked}
            changeReload={changeReload}
            setRadioData={setRadioData}
            setCancelDisabled={setCancelDisabled}
            config={props.config}
            key="spaceBlock"
          />
        );        
        openlightbox(as);
      }
    }

    props.changeLoader(false);
  };

  const blockUnblock = async () => {
    if (radioData === null || radioData.lenght === 0) {
      return;
    }
    if (blockDisabled) {
      return;
    }

    const b = !blocked;
    let data = {
      customerUuid: props.item.data.customerUuid, //TWO_FACTOR_AUTH
      spaceUuid: radioData.uuid,
      action: 'unblock',
    };
    props.changeLoader(true);

    let request = await API.service('spaceBlockUnblock', data, props.pos, props.changeAlert, props.changeLoader, history);
    if (request.status == 200 && request.data.data.response == 'OK' && request.data.data.widget.length == 0 && request.data.data.content) {
      if(request.data.data.content.type == '2FA' || request.data.data.content.type == '1FA'){
        let factors = localStorage.factors ? JSON.parse(localStorage.factors) : {};
        factors[props.item.data.customerUuid] = request.data.data.content.uuid_factor;
        localStorage.factors = JSON.stringify(factors);
      }
      const as = <Modals.Factor
          intent="spaceBlockUnblock"
          contentModal={request.data.data.content}
          pos={props.pos}
          changeAlert={props.changeAlert}
          changeLoader={props.changeLoader}
          history={history}
          key="factor"
      />
      openlightbox(as);
    }
    if (request.status == 200 && request.data.data.response == 'OK' && (request.data.data.widget.length === 0 || request.data.data.widget.length > 0) && !request.data.data.content) {
      setBlocked(b);
      setCancelDisabled(true); 
      setRadioData(null);
      radioData.status = b ? 'Bloqueado' : 'Activo';
      await changeReload()
      props.changeAlert(true, 'success', 'Datos actualizados con éxito');
    }
   
    props.changeLoader(false);
  };

  const findDisabledSpaces = async () => {
    props.changeLoader(true);
    let payload = {
      uuid: props.item.data.customerUuid
    }
    let response = await API.service('findDisabledSpaces', payload, props.pos, props.changeAlert, props.changeLoader, history);
    if (response.status == 200) {
        if (response.data.data.response == 'OK') {
          setDisabled(true);
          setHasFilter(true);
          let p = propsModal;
          let newData = p['data']['content'].concat(response.data.data.content);
          p['data']['content'] = newData;
          setPropsModal(p);
        } else {
          props.changeAlert(true, 'error', response.data.data.message);
        }
    }
    props.changeLoader(false);
}

  const cancel = (widg) => {
    const as = <Modals.SpaceCancel
      content={widg.content}
      customerUuid={props.item.data.customerUuid}
      pos={props.pos}
      changeAlert={props.changeAlert}
      changeLoader={props.changeLoader}
      changeWidgets={props.changeWidgets}
      changeReload={changeReload}
      setRadioData={setRadioData}
      key="spaceCancel"
    />
    openlightbox(as);
  };

  const getCatalog = async () => {
    if(catalogLevel.length > 0){
      setCatalogLevel([])
      setUpgrade(true)
    } else {      
      props.changeLoader(true);
      setUpgrade(false)
      let data = {
        catalog: {
          id: "customer.subproducts",
        },
      };
      
      let request = await API.service('getCatalog', data, props.pos, props.changeAlert, props.changeLoader, history);
      if (request.status == 200 && request.data.data.response == 'OK') {
        setCatalogLevel(request.data.data.catalog)
      }
      props.changeLoader(false);
    }
  }

  const hasAction = (action) => {
    return props.config?.actions?.indexOf(action) > -1;
  };

  const filterRemoveSpaceDeleted = async () => {
    let auxTxs = [];
    props.changeLoader(true);

    if (!hasFilter || disabled) {
      for (let index = 0; index < props.item.data.content.length; index++) {
        if (props.item.data.content[index].status !== "Inactivo") {
          auxTxs.push(props.item.data.content[index]);
        }
      }
      setHasFilter(true);
      setPropsModal({
        config: props.item.config,
        data: {
          columns: props.item.data.columns,
          content: auxTxs,
          customerUuid: props.item.data.customerUuid,
        },
        type: props.item.type,
      });
    } else {
      setHasFilter(false);
      setPropsModal(props.item);
    }
    if(disabled){
      setHasFilter(false);
      setDisabled(false)
    }
    
    props.changeLoader(false);
  };

  const hasField = (field) => {
    return props?.["config"]?.fields?.in?.indexOf(field) > -1;
  };

  return (
    <Paper className={clasess.limitsDetail} sx={{pb: 2}}>
      <Typography
        component="div"
        children={
          <div className={clasess.titleTable} style={{padding: "10px"}}>
            <h2 className={clasess.titleH2}>
              <AccountCircle className={clasess.iconTitle2} fontSize="large"/>
              Cuentas de Débito
            </h2>

            <div className={`switcher mini padding-right col-4 desktop ${hasFilter ? "active" : ""}`} onClick={disabled ? filterRemoveSpaceDeleted.bind(this) : findDisabledSpaces.bind(this)}>
              <div className="switcherSlider slider-tx" style={{marginRight: 10}}>
                <div className="switcherSliderCircle" />
              </div>
              <span className="space-tx"> </span>
              {disabled ?
                <label className="btn-txs">Ocultar espacios inactivos</label>
                :
                <label className="btn-txs">Buscar espacios inactivos</label>
              }
            </div>

            <div className="col-5 inputIconRight">
              <div className="row pos-right">
                {hasAction("levelUpgrade") && (
                  <div>
                    <IconButton onClick={getCatalog.bind(this)}><TrendingUp fontSize="large"/></IconButton>
                    <label style={{paddingRight: "26px" }}>{upgrade ? "Editar Nivel" : "Ocultar Nivel"}</label>
                  </div>
                )}
                {hasAction("block") && (
                  <div className={`switcher mini padding-right desktop fx-switcher-top ${blocked ? "active" : ""} ${blockDisabled ? "disable" : ""}`} onClick={blocked ? blockUnblock : blockW}>
                    <div className="switcherSlider"><div className="switcherSliderCircle" /></div>
                    <label className="col-3 fix-lb-spaces-bloq">{blocked ? "Desbloquear" : "Bloquear"}</label>
                  </div>
                )}
                {hasAction("cancel") && (
                  <div className={cancelDisabled ? "bigButton padding-right desktop disable" : "bigButton padding-right desktop" }>
                    <button onClick={validation.bind(this)} disabled={cancelDisabled}>
                      Cancelar
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        }
      />

      <Typography
        component="div"
        children={
          <div className={`size-12 ${clasess.card_type1}`} >
            { props.item["data"]["vip"] ? hasField("vip") ? <p className="pnl-ltr-ind"><label>Saldo Disponible: {balance}</label></p> : null : <p className="pnl-ltr-ind"><label>Saldo Disponible: {balance}</label></p>}
            <p className="pnl-ltr-ind"><label>Espacios Totales:{" "} {props.item.data.content.length}</label></p>
            <p className="pnl-ltr-ind"><label>Selecciona una cuenta para su edición:</label></p>
          </div>
        }
      />

      <Elements.SpaceTable
        data={propsModal}
        pos={props.pos}
        config={props.config}
        changeAlert={props.changeAlert}
        changeLoader={props.changeLoader}
        catalog={catalogLevel}
        openpayPrefix={openpayPrefix}
        changeReload={changeReload}
        changeRadio={onClickRadio}
      />
    </Paper>  
  );
};

export default Spaces;